import { ActionBrick, registerBrick } from 'olympe';

export default class GetAzureReadImageResult extends ActionBrick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {string} readURL
     * @param {string} ocpApimSubscriptionKey
     * @param {number} pollEverySeconds
     * @param {function()} forwardEvent
     * @param {function(string)} setFullJSON
     * @param {function(string)} setResult
     * @param {function(Map)} setListOfLines
     * @param {function(*)} setErrorFlow
     */
    update(context, [readURL, ocpApimSubscriptionKey, pollEverySeconds], [forwardEvent, setFullJSON, setResult, setListOfLines, setErrorFlow]) {
        // Target URL must have this specific format:
        if (!/^https:\/\/[A-z0-9._+~/-]+\/vision\/v\d\.\d\/read\/analyzeResults\//.test(readURL)) {
            setResult('Given url is not valid: ' + readURL);
            setErrorFlow();
            return;
        }
        // By default, if value is not between 0.5 and 10 seconds, set poll rate to 1.5 second
        if (!pollEverySeconds || pollEverySeconds > 10 || pollEverySeconds < 0.5) {
            pollEverySeconds = 1.5;
        }

        // N.B.: parsing greatly copied from "ParseAzureOCRResponse.js", except that "Regions" are here "Pages"
        const handleSuccess = (responseData) => {
            const listOfLines = new Map();
            let plainText = '';
            let success = false;
            let index = 0;
            try {
                // OBJECT STRUCTURE = cf. top of file
                const readResults = responseData["analyzeResult"]["readResults"];
                // Handle each line separately
                for (const page of readResults) {
                    for (const line of page["lines"]) {
                        let currentLine = '';
                        for (const word of line["words"]) {
                            // add a space between each word
                            currentLine += (word["text"] + ' ');
                        }
                        // remove last space
                        currentLine = currentLine.substr(0, currentLine.length - 1);
                        // store new line (use the Page number as ID, so that we can retrieve them by page later if needed)
                        listOfLines.set(page["page"] + '_' + index, currentLine);
                        // add line feed at the end of line
                        plainText += (currentLine + '\n');
                    }
                    // add line feed at the end of page (i.e. there will be an empty line between 2 pages)
                    plainText += '\n';
                }
                setResult(plainText);
                setListOfLines(listOfLines);
                success = true;
            } catch (jsonErr) {
                console.error(jsonErr);
                setResult('Error while parsing Read response.');
                setErrorFlow();
            }
            if (success) {
                forwardEvent();
            }
        };

        // Request the Azure service:
        const requestReading = () => {
            setTimeout(() => {
                // Wait "n" seconds before re-sending the request (P.S.: request itself will not change)
                this.httpRequest(readURL, ocpApimSubscriptionKey, (responseStatus, _, response) => {
                    if (
                        responseStatus === 200 ||
                        responseStatus === 202
                    ) {
                        const responseData = JSON.parse(response);
                        const readingStatus = responseData["status"];

                        // If operation is still in progress, request again
                        if (readingStatus === "notStarted" || readingStatus === "running") {

                            // If operation is successful, get AnalyzeResult
                            // and set the full plain JSON as string output
                        } else if (readingStatus === "succeeded") {
                            setFullJSON(response);
                            handleSuccess(responseData);

                        } else if (readingStatus === "failed") {
                            setResult('Image reading failed: ' + responseData);
                            setErrorFlow();
                        } else {
                            setResult('Unknown error: ' + responseData);
                            setErrorFlow();
                        }
                    } else {
                        setResult('Request error: ' + response);
                        setErrorFlow();
                    }
                });
            }, pollEverySeconds * 1000);
        };

        // Start looping
        requestReading();
    }

    httpRequest(url, ocpApimSubscriptionKey, callback) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('Ocp-Apim-Subscription-Key', ocpApimSubscriptionKey);

        // Set on load callback
        xhr.onloadend = () => {
            callback(xhr['status'], xhr['statusText'], xhr['response'], xhr.getAllResponseHeaders());
        };

        // Send request
        xhr.send();
    }
}

registerBrick('0178126394578f0047c4', GetAzureReadImageResult);
